import React from 'react';
import styled from 'styled-components';
import ScrollAnimation from 'react-animate-on-scroll';

const Container = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  justify-content: center;
  align-items: center;
  & > div {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    & > h2 {
      position: relative;
      text-align: left;
      font-weight: 400;
      font-size: 54px;
      letter-spacing: 0.05em;
      line-height: 140%;
      color: ${props => props.color == 'yellow' ? '#FF8E00' : '#090C32'};
      z-index: 10;
    }
    & > div:nth-child(2) {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 0;
      width: 100%;
      & > h2 {
        margin-left: 3px;
        margin-top: 3px;
        -webkit-text-stroke: ${props => props.color == 'yellow' ? '1px #fff' : '2px #F600C1'};;
        color: transparent;
        position: relative;
        text-align: left;
        font-weight: 400;
        font-size: 54px;
        letter-spacing: 0.05em;
        line-height: 140%;
        z-index: 10;
        word-break: keep-all;
        word-wrap: normal;
      }
    }
  }
  @media (max-width: 1210px) {
    width: 100%;
    margin-left: 0;
    padding: 0 20px;
    & > div {
      & > h2 {
        text-align: center;
      }
      & > div:nth-child(2) {
        display: flex;
        justify-content: center;
        & > h2 {
          text-align: center;
        }
      }
    }
  };
  @media (max-width: 430px) {
    & > div {
      & > h2 {
        font-size: 44px;
      }
      & > div:nth-child(2) {
        & > h2 {
          font-size: 44px;
        }
      }
    }
  };
`

const Title = ({ text, color }) => {
  return (
    <Container color={color}>
      <ScrollAnimation animateIn='fadeInUp'>
        <h2>{text}</h2>
        <div>
          <h2>{text}</h2>
        </div>
      </ScrollAnimation>
    </Container>
  )
}

export default Title;